<template>
    <div class="app-loader">
        <div class="loader-container">
            <div class="container-inner">
                <img src="@/assets/img/small_logo.png" />
            </div>
        </div>
        <canvas id="background-canvas"></canvas>
    </div>
</template>

<script>
    export default {
        name: 'AppMaintenance',
        mounted() {
            this.startBackgroundAnimation();
        },
        methods: {
            startBackgroundAnimation() {
                const canvas = document.getElementById('background-canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = window.innerWidth;
                canvas.height = window.innerHeight;

                const particlesArray = [];
                const numberOfParticles = 100;

                class Particle {
                    constructor() {
                        this.x = Math.random() * canvas.width;
                        this.y = Math.random() * canvas.height;
                        this.size = Math.random() * 3 + 1;
                        this.speedX = Math.random() * 2 - 1;
                        this.speedY = Math.random() * 2 - 1;
                    }

                    update() {
                        this.x += this.speedX;
                        this.y += this.speedY;

                        if (this.x > canvas.width || this.x < 0) this.speedX *= -1;
                        if (this.y > canvas.height || this.y < 0) this.speedY *= -1;
                    }

                    draw() {
                        ctx.beginPath();
                        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                        ctx.fillStyle = 'rgba(0, 142, 204, 0.5)';
                        ctx.fill();
                    }
                }

                function init() {
                    for (let i = 0; i < numberOfParticles; i++) {
                        particlesArray.push(new Particle());
                    }
                }

                function animate() {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    particlesArray.forEach((particle) => {
                        particle.update();
                        particle.draw();
                    });
                    requestAnimationFrame(animate);
                }

                init();
                animate();
            },
        },
    };
</script>

<style scoped>
    .app-loader {
        width: 100%;
        height: 100%;
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        background: #001e37;
        overflow: hidden;
    }

    .app-loader .loader-container {
        width: 160px;
        height: 160px;
        position: relative;
        padding: 2px;
        border-radius: 50%;
        overflow: hidden;
        z-index: 2;
    }

    .app-loader .loader-container::before {
        content: '';
        width: 160px;
        height: 160px;
        position: absolute;
        top: 50%;
        left: 50%;
        background: linear-gradient(90deg, rgba(48, 83, 116, 0.2) 25%, #01ebae 100%);
        z-index: -1;
        animation: rotateAnimation 2s linear infinite;
    }

    .app-loader .container-inner {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: radial-gradient(285% 150% at 50% 50%, #001e37 0%, #000e1a 100%);
        overflow: hidden;
    }

    .app-loader .container-inner img {
        width: 140px;
    }

    #background-canvas {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    @keyframes rotateAnimation {
        0% {
            transform: translate(-50%, -50%) rotate(0deg);
        }
        100% {
            transform: translate(-50%, -50%) rotate(360deg);
        }
    }
</style>
